export const baseUrl: any = "https://api.haodymadagascar.com/";
// export const baseUrl: any = "http://localhost:3002/"
